module.exports = __webpack_public_path__ + "static/img/u36.0f1abe47.png";